const resumo_de_alunos_por_deficiencia = [
  {
    path: "/resumo-de-alunos-por-deficiencia",
    redirect: "/resumo-de-alunos-por-deficiencia",
    meta: {
      breadCrumb: "Gestão - Informação Complementar do Aluno",
    },
    children: [
      {
        path: "/resumo-de-alunos-por-deficiencia",
        name: "resumo_de_alunos_por_deficiencia",
        component: () =>
          import(
            "@/views/ResumoDeAlunosPorDeficiencia/ResumoDeAlunosPorDeficiencia.vue"
          ),
      },
    ],
  },
];

export { resumo_de_alunos_por_deficiencia };
